export enum UserRole {
  ADMIN = 'Administrator',
  USER = 'User',
  READER = 'Reader',
  FULL_ACCESS = 'Full Access'
}
